export const checkFilter = (filters) => {
	let newFilter = {};

	for (const key in filters) {
		let value = filters[key];

		// Guard khusus: backend mengharapkan string scalar untuk partial name filter
		if (key === "filter[name_start]") {
			if (Array.isArray(value)) {
				const firstValidValue = value.find(
					(item) =>
						item !== "" &&
						item !== null &&
						item !== undefined &&
						typeof item !== "object"
				);

				value = firstValidValue ?? "";
			} else if (value === null || value === undefined) {
				value = "";
			} else if (typeof value !== "string") {
				value = String(value);
			}
		}

		// Buang value kosong, null, undefined, dan array kosong
		if (
			value !== "" &&
			value !== null &&
			value !== undefined &&
			!(Array.isArray(value) && value.length === 0)
		) {
			newFilter[key] = value;
		}
	}

	return newFilter;
};